import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LogIn from "./components/userSignIn/User-Sign-In.js";
import ClippedDrawer from "./components/drawer/Drawer.js";
import Dashboard from "./components/dashboard/Dashboard.js";
import Trips from "./components/trips/Trips.js";
import TripDetails from "./components/trips/Trip-Details.js";
import Drivers from "./components/drivers/Drivers.js";
import Trucks from "./components/trucks/Trucks.js";
import TruckOwners from "./components/truckOwners/Truck-Owners.js";
import TruckOwnerDetails from "./components/truckOwners/Truck-Owner-Details.js";
import ManageUsers from "./components/users/Users.js";
import DeliveryZones from "./components/deliveryZones/DeliveryZones.js";
import Settings from "./components/settings/Settings.js";
import Profile from "./components/settings/Profile.js";
import BillingSettings from "./components/settings/Billing.js";
import Package from "./components/settings/package.js";
import Payments from "./components/paymentModule/PaymentModule.js";
import DeliveryAreas from "./components/deliveryAreas/DeliveryAreas.js";
import DriverProfile from "./components/drivers/DriverDetails.js";
import TruckDetails from "./components/trucks/Truck-Details.js";
import UserDetails from "./components/users/UserDetails.js";
import Packages from "./components/packages/Packages.js";
import PackagesInfo from "./components/packages/PackageInfo.js";

function AppRouter() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LogIn />} />
                <Route path="/app" element={<ClippedDrawer />}>
                    <Route index element={<Dashboard />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="trips" element={<Trips />} />
                    <Route path="trip-details/:id" element={<TripDetails />} />
                    <Route path="drivers" element={<Drivers />} />
                    <Route path="driver-details/:id" element={<DriverProfile />} />
                    <Route path="trucks" element={<Trucks />} />
                    <Route path="truck-details/:id" element={<TruckDetails />} />
                    <Route path="truck-owners" element={<TruckOwners />} />
                    <Route path="owner" element={<TruckOwnerDetails />} />
                    <Route path="users" element={<ManageUsers />} />
                    <Route path="user-details/:id" element={<UserDetails />} />
                    <Route path="delivery-zones" element={<DeliveryZones />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="billing-settings" element={<BillingSettings />} />
                    <Route path="package-management" element={<Package />} />
                    <Route path="payments" element={<Payments />} />
                    <Route path="packages" element={<Packages />} />
                    <Route path="package-info/:id" element={<PackagesInfo />} />
                    <Route path="*" element={<Navigate to="dashboard" replace />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default AppRouter;
